import Modal from './components/modal'

export default class CartButton {
    constructor(element) {
        this.button = element;
        this.ajaxButton = this.button.querySelector('.ajax-button')
        this.cartModalElement = this.button.querySelector('#cart-modal')

        // Init modal
        this.cartModal = new Modal(this.cartModalElement)

        // Clicks ajax button
        this.ajaxButton.addEventListener('click', (e) => {
            e.preventDefault();

            if(!this.ajaxButton.classList.contains('button-disabled')) {
            this.handleAjaxCall();
            }
        })
    }

    getQuantity() {
        return this.ajaxButton.getAttribute('data-quantity')
    }

    getProductId() {
        return this.ajaxButton.getAttribute('data-product_id')
    }

    getVariationId() {
        return this.ajaxButton.getAttribute('data-variation_id')
    }

    handleAjaxCall() {
        this.ajaxButton.classList.add('button-loading')
        const productId = this.getProductId()
        const variationId = this.getVariationId()
        const quantity = this.getQuantity()
        
        let url = `/?add-to-cart=${productId}&quantity=${quantity}`;
        url = variationId ? url + `&variation_id=${variationId}` : url;

        const request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.onload = () => {
            if (request.status >= 200 && request.status < 400) {
                window.visitHoogstratenCart.add(parseInt(quantity))
                this.cartModal.open()
                this.ajaxButton.classList.remove('button-loading')
            } else {
            }
        };

        request.onerror = function () {
            // There was a connection error of some sort
        };

        request.send()
    }

    updateCartQuantity(quantity) {
        const cart = document.querySelector('.header-top-cart')
        const cartQuantity = cart.getElementsByTagName('span')

        if (cartQuantity[0]) {
            const updateQuantity = parseInt(cartQuantity[0].innerHTML) + parseInt(quantity);
            cartQuantity[0].innerHTML = updateQuantity.toString();
        } else {
            // No span exists so first create one and add quantity
            const newCartQuantity = document.createElement('span');
            cart.appendChild(newCartQuantity)
            const newQuantity = parseInt(quantity);
            newCartQuantity.innerHTML = newQuantity.toString();
        }
    }

}